import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HistoricoRetosPage } from './historico-retos';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    HistoricoRetosPage,
  ],
  imports: [
    IonicPageModule.forChild(HistoricoRetosPage),
    PipesModule,
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class HistoricoRetosPageModule {}



// WEBPACK FOOTER //
// ./src/pages/historico-retos/historico-retos.module.ts